/**
 * Przełącznik okna zlecenia wg makiety FTL (Etap 1, 15.10.2026). Klucz to
 * dane (wiersz w bazie, rejestr w API: `feature-flags/feature-flags.ts`) —
 * nie przemianowujemy. Wyłączony: karta zlecenia jak dotąd.
 */
export const FEATURE_ORDER_WINDOW = 'orderWindowLayout';
